import React, { Component } from "react";
import { Card, Table } from "antd";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import util from "@util/index";

class TableDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  columns = () => {
    return [
      {
        title: "当前月份",
        dataIndex: "month",
      },
      {
        title: "预算支出（预算实际支出）",
        dataIndex: "budgetExpenditure",
        render: text => {
          return <span>{text ? util.numberFormat(text) : 0}</span>;
        },
      },
      {
        title: "实际收入（去除往来款）",
        dataIndex: "actualIncome",
        render: text => {
          return <span>{text ? util.numberFormat(text) : 0}</span>;
        },
      },
      {
        title: "实际支出",
        dataIndex: "actualExpenditure",
        render: text => {
          return <span>{text ? util.numberFormat(text) : 0}</span>;
        },
      },
      {
        title: "实际利润（实际收入-预算支出）",
        dataIndex: "actualProfit",
        render: text => {
          return <span>{text ? util.numberFormat(text) : 0}</span>;
        },
      },
    ];
  };

  render() {
    const {
      data: { list },
      handleChange,
    } = this.props;
    return (
      <div className="analyze">
        <Card
          title={
            <div>
              <span>利润追踪详情表</span>
              <span>单位（元）</span>
            </div>
          }
          extra={
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button ant-btn"
              table="table-to-xls"
              filename="tablexls"
              sheet="tablexls"
              style={{
                marginTop: "4px",
              }}
              buttonText="导出"
            />
          }
        >
          <Table
            columns={this.columns()}
            dataSource={list}
            pagination={false}
            onChange={handleChange}
            id="table-to-xls"
          />
        </Card>
      </div>
    );
  }
}
export default TableDetail;



// WEBPACK FOOTER //
// ./src/components/incubator/analyze/profit/TableDetail.js